/**
 * The method below uses the auth integration to return an access token
 * which will be used when making calls to the API.
 */
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { useSessionStore, useEMandatesStore } from "@/plugins/store";
import { redirectToRoute } from "@/plugins/router";
import { routeNames } from "@/constants/routeNames";
import { useAlert } from "@esenda/core-ui/composables";
import { useOrganisationStore } from "@/plugins/store";

const { showAlert } = useAlert();

const postLogoutRedirect = () => {
    /**
     * Determine which route to send user to after logout
     * based on the origin
     */
    const eMandatesStore = useEMandatesStore();
    const orgStore = useOrganisationStore();
    const sessionStore = useSessionStore();

    if (!orgStore.shortcode) {
        redirectToRoute(routeNames.DEFAULT, {});
        return;
    }

    if (sessionStore.origin === routeNames.E_MANDATES_LANDING_PAGE) {
        redirectToRoute(routeNames.E_MANDATES_LANDING_PAGE, {
            shortcode: orgStore.shortcode,
            accountAlias: eMandatesStore.accountAlias,
        });
    } else {
        const formName = orgStore.formName ?? "invoice";
        redirectToRoute(routeNames.FORM, {
            shortcode: orgStore.shortcode,
            form: formName,
        });
    }
};

export const getToken = async () => {
    const sessionStore = useSessionStore();

    try {
        const session = await fetchAuthSession();
        const token = session.tokens?.accessToken;
        if (!token) {
            //** Sign out user if we cannot get a token */
            sessionStore.setIsAuthenticated(false);
            sessionStore.setUser(null);

            await signOut({ global: true });

            showAlert("alerts.expiredSession");
            postLogoutRedirect();
            return null;
        }
        return token;
    } catch (error) {
        /** Sign out user if a token cannot be retrieved */
        sessionStore.setIsAuthenticated(false);
        sessionStore.setUser(null);

        await signOut({ global: true });
        showAlert("alerts.expiredSession");
        postLogoutRedirect();
        return null;
    }
};
